// src/pages/Achievement.js
import React from "react";
import { Container, Card, ListGroup } from "react-bootstrap";

const achievements = [
  {
    year: "2024",
    description:
      "Received appreciation at Astrapia Consulting LLP for designing scalable backend REST APIs using Spring Boot.",
  },
  {
    year: "2023",
    description:
      "Recognized as 'Developer of the Month' at SourceEase HR Services for delivering quality backend development and database design.",
  },
  {
    year: "2022",
    description: "Placed at IIT Roorkee through internal placement drive.",
  },
  {
    year: "2015",
    description: "Ranked in the top 0.4% of students in IIT JEE Advanced.",
  },
  {
    year: "N/A",
    description: "Languages: English, Hindi.",
  },
  {
    year: "N/A",
    description:
      "Earned NCC ‘C’ Certificate from 3UK CTR, IIT Roorkee; led the Guard of Honor parade multiple times.",
  },
  {
    year: "N/A",
    description:
      "Awarded Merit-Cum-Means (MCM) Scholarship under MHRD based on academic excellence.",
  },
  {
    year: "N/A",
    description:
      "Led as the primary volunteer for the Art of Living course at IIT Roorkee, focused on enhancing mental well-being.",
  },
];

const Achievement = () => {
  return (
    <Container className="mt-4">
      <h2 className="text-white text-center mb-4">🏆 Achievements</h2>

      <Card className="bg-dark text-white shadow">
        <ListGroup variant="flush">
          {achievements.map((item, idx) => (
            <ListGroup.Item
              key={idx}
              className="bg-dark text-white border-bottom border-secondary d-flex justify-content-between"
            >
              <span>{item.description}</span>
              <span className="text-info fw-semibold">{item.year}</span>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card>
    </Container>
  );
};

export default Achievement;
